// Persone.tsx — v033: pezzi in comune tra Amici, Disponibili ora e Wall of Fame: la riga di una persona (avatar con il
// pallino verde quando è online, nome, @nome) e la sfida mandata a qualcuno (poi si va alla pagina della sfida, dove si
// aspetta che l'altro accetti, come con il link personale).
import { useState, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Avatar } from "../componenti/Avatar.tsx";
import { ErroreRete } from "../servizi/api.ts";
import { useAccount } from "../servizi/account.ts";
import { salvaToken, type SfidaCreata } from "../servizi/sfide.ts";
import { vai } from "../servizi/percorso.ts";
import { vibra } from "../servizi/nativo.ts";
import { PERCORSO_SFIDA } from "../costanti.ts";

export function RigaPersona({ nome, nomeUtente, avatar, online, stato, children, angolo }: { nome: string; nomeUtente: string | null; avatar: number | null; online?: boolean; stato?: string; children?: ReactNode; angolo?: ReactNode }) {
  const { t } = useTranslation();
  return (
    <li className="ld-persona" data-online={online === true} data-angolo={angolo ? true : undefined}>
      {/* v041: un'azione «particolare» (togli dagli amici) in alto a destra, piccola e di un altro colore */}
      {angolo && <span className="ld-persona-angolo">{angolo}</span>}
      <span className="ld-persona-avatar">
        <Avatar quale={avatar ?? "mistero"} dimensione={48} />
        {online !== undefined && <span className="ld-pallino" data-online={online} aria-label={online ? t("amici.online") : t("amici.offline")} role="img" />}
      </span>
      <span className="ld-persona-chi">
        <strong>{nome}</strong>
        {nomeUtente && (
          <span className="nota" translate="no">
            @{nomeUtente}
          </span>
        )}
        {stato && <span className="ld-persona-stato">{stato}</span>}
      </span>
      {children && <span className="ld-persona-azioni">{children}</span>}
    </li>
  );
}

const ERRORI_NOTI = ["link_spento", "troppe_richieste", "quota_finita", "troppe_sfide", "sospeso", "gioco_spento", "offline", "timeout", "non_trovato"];

/** Manda una sfida e va alla pagina della sfida. `errore` è il codice da mostrare (social.errore_*). */
export function usaSfidaPersona() {
  const account = useAccount();
  const [invio, setInvio] = useState<string | null>(null);
  const [errore, setErrore] = useState<string | null>(null);
  const mioNome = account.tipo === "registrato" ? account.io.nome : "";
  const sfida = async (chiave: string, manda: (mioNome: string) => Promise<SfidaCreata & { per: { nome: string } }>) => {
    setInvio(chiave);
    setErrore(null);
    try {
      vibra("medio");
      const s = await manda(mioNome);
      salvaToken(s.codice, s.token, s.per.nome);
      vai(`${PERCORSO_SFIDA}${s.codice}`);
    } catch (e) {
      const c = e instanceof ErroreRete ? e.codice : "generico";
      setErrore(ERRORI_NOTI.includes(c) ? c : "generico");
      setInvio(null);
    }
  };
  return { sfida, invio, errore, setErrore };
}

/** Il messaggio di errore di una sfida mandata. */
export function ErroreSfida({ codice }: { codice: string | null }) {
  const { t } = useTranslation();
  if (!codice) return null;
  return (
    <p className="admin-errore" role="alert">
      {codice === "non_trovato" ? t("amici.non_piu_disponibile") : t(`social.errore_${codice}`, { defaultValue: t("gioco.errore_generico") })}
    </p>
  );
}

export function IconaSfida() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  );
}
